export const AcGenerateThemeClassNames = prefix => {
  return {
    ALPHA: `${prefix}--alpha`,
    ALPHA_LIGHT: `${prefix}--alpha-light`,
    ALPHA_MEDIUM: `${prefix}--alpha-medium`,
    ALPHA_DARK: `${prefix}--alpha-dark`,
    ALPHA_PITCH: `${prefix}--alpha-pitch`,
    OMEGA: `${prefix}--omega`,
    OMEGA_LIGHT: `${prefix}--omega-light`,
    OMEGA_MEDIUM: `${prefix}--omega-medium`,
    OMEGA_DARK: `${prefix}--omega-dark`,
    OMEGA_PITCH: `${prefix}--omega-pitch`,
    BETA: `${prefix}--beta`,
    BETA_LIGHT: `${prefix}--beta-light`,
    BETA_LIGHTEST: `${prefix}--beta-lightest`,
    BETA_MEDIUM: `${prefix}--beta-medium`,
    BETA_DARK: `${prefix}--beta-dark`,
    CHARLIE: `${prefix}--charlie`,
    CHARLIE_LIGHT: `${prefix}--charlie-light`,
    ECHO: `${prefix}--echo`,
    ECHO_LIGHT: `${prefix}--echo-light`,
    ECHO_MEDIUM: `${prefix}--echo-medium`,
    ECHO_DARK: `${prefix}--echo-dark`,
    DEFAULT: `${prefix}--default`,
    TRANSPARENT: `${prefix}--transparent`,
    WHITE: `${prefix}--white`,
    EGGWHITE: `${prefix}--eggwhite`,
    OFFWHITE: `${prefix}--offwhite`,
    LIGHT: `${prefix}--light`,
    SUBTLE: `${prefix}--subtle`,
    MEDIUM: `${prefix}--medium`,
    DARK: `${prefix}--dark`,
    PITCH: `${prefix}--pitch`,
    BLACK: `${prefix}--black`,
    SUCCESS: `${prefix}--success`,
    SUCCESS_LIGHT: `${prefix}--success-light`,
    ERROR: `${prefix}--error`,
    ERROR_LIGHT: `${prefix}--error-light`,
    WARNING: `${prefix}--warning`,
    WARNING_LIGHT: `${prefix}--warning-light`,
    INFO: `${prefix}--info`,
    INFO_LIGHT: `${prefix}--info-light`,
  };
};

export const AcGenerateThemeKeys = prefix => {
  return [
    'alpha',
    'alpha_light',
    'alpha_medium',
    'alpha_dark',
    'alpha_pitch',
    'omega',
    'omega_light',
    'omega_medium',
    'omega_dark',
    'omega_pitch',
    'beta',
    'beta_light',
    'beta_lightest',
    'beta_medium',
    'beta_dark',
    'charlie',
    'charlie_light',
    'echo',
    'echo_light',
    'echo_medium',
    'echo_dark',
    'default',
    'transparent',
    'white',
    'eggwhite',
    'offwhite',
    'light',
    'subtle',
    'medium',
    'dark',
    'pitch',
    'black',
    'success',
    'success_light',
    'error',
    'error_light',
    'warning',
    'warning_light',
    'info',
    'info_light',
  ];
};

export const AcGenerateThemeList = prefix => {
  return [
    'alpha',
    'alpha_light',
    'alpha_medium',
    'alpha_dark',
    'alpha_pitch',
    'omega',
    'omega_light',
    'omega_medium',
    'omega_dark',
    'omega_pitch',
    'beta',
    'beta_light',
    'beta_lightest',
    'beta_medium',
    'beta_dark',
    'charlie',
    'charlie_light',
    'echo',
    'echo_light',
    'echo_medium',
    'echo_dark',
    'default',
    'transparent',
    'white',
    'eggwhite',
    'offwhite',
    'light',
    'subtle',
    'medium',
    'dark',
    'pitch',
    'black',
    'success',
    'success_light',
    'error',
    'error_light',
    'warning',
    'warning_light',
    'info',
    'info_light',
  ];
};

export default AcGenerateThemeClassNames;
